export const baseURL = `${import.meta.env.VITE_AUTH_RTC}/connection/websocket`
